module.exports = __webpack_public_path__ + "static/media/airplane_preloader.7ec130a0.svg";